// extracted by mini-css-extract-plugin
export default {"constructor_element":"burger-constructor-element_constructor_element__7XDRs"};